// removed by extract-text-webpack-plugin
module.exports = {"base":"Options_base--1hFbu","base__viewInline":"Options_base__viewInline--1Wgnj","baseViewInline":"Options_base__viewInline--1Wgnj","item":"Options_item--1Kyr5"};


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Options/Options.scss
// module id = 502
// module chunks = 11 12